/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Link {
  /**
   * An absolute URL linking to a resource.
   * @example "https://..."
   */
  href?: string;
}

export interface Links {
  next?: Link;
  previous?: Link;
}

export interface ErrorResponse {
  /**
   * A correlation id used for reference when contacting support.
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  requestId?: string;
  /** Details about the error. */
  error?: Error;
}

/** Details about the error. */
export interface Error {
  /**
   * Machine-readable error code.
   * @example "ConstraintViolationError"
   */
  code?: string;
  /**
   * Human-readable error message.
   * @example "The request was malformed."
   */
  message?: string;
  /**
   * Optional field used to point to a problematic part of the request.
   * @example "31192dc9-eb45-4d90-b606-21e9b66d8c2b"
   */
  target?: string;
  details?: Error[];
}

/** A typed model which describes a restriction pertaining to a platform entity. */
export interface Restriction {
  /** The restriction level of an entity to limit actions it can take. */
  tier: number;
  /** The number of days to retain the state before deletion. */
  historyRetentionTTLDays?: number;
  /**
   * Indicate whether or not the entity is visible when restricted.
   * @default false
   */
  visibleWhenRestricted?: boolean;
}

/**
 * A typed model which provides information around ownership of a specific domain.
 * @example {"ownerType":"USER","ownerId":"72fd3b54-d243-4bf7-a845-92eb7956b982"}
 */
export interface Owner {
  /**
   * The type of owner that owns this entity. "Account" refers specifically to a coterie account ID.
   * @default "USER"
   */
  ownerType: 'USER' | 'SYSTEM' | 'IMPLICIT' | 'ACCOUNT';
  /** A global identifier for owner. */
  ownerId: string;
}

export interface OcfDeviceProfiles {
  items?: OcfDeviceProfile[];
}

/** @example {"commands":[{"component":"main","capability":"colorTemperature","command":"setColorTemperature","arguments":["30000"]}]} */
export interface DeviceCommandsRequest {
  /** An array of commands to execute on the Device. */
  commands?: DeviceCommand[];
}

/** @example {"component":"main","capability":"switchLevel","command":"setLevel","arguments":[80]} */
export interface DeviceCommand {
  /**
   * The name of the component on this device, default is 'main'. The component must be valid for the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @default "main"
   */
  component?: string;
  /** Capability that this command relates to. This must be a capability of the component. */
  capability: string;
  /** Name of the command, this must be valid for the capability. */
  command: string;
  /**
   * Arguments of the command.
   * All the required arguments defined in the capability's command argument definition must be provided.
   * The type of the arguments are dependent on the type of the capability's command argument.
   * Please refer to the capabilities definition at https://developer-preview.smartthings.com/docs/devices/capabilities/capabilities-reference
   */
  arguments?: object[];
  /** The id on the command that triggered this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
}

export interface BatchDeviceCommandsRequest {
  /** An array of commands to execute on the specified Device. */
  commands?: BatchDeviceCommand[];
}

export type BatchDeviceCommand = {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
} & DeviceCommand;

export interface DeviceEventsRequest {
  /**
   * An array of attribute state updates.
   * @maxItems 8
   * @minItems 1
   */
  deviceEvents?: DeviceStateEvent[];
}

export interface IdLessHealthState {
  /** Current state of the device */
  state?: 'ONLINE' | 'OFFLINE';
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate?: string;
}

/** A paginated array of Devices. */
export interface PagedDevices {
  items?: Device[];
  _links?: Links;
}

export interface Device {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The identifier for the owner of the device instance.
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId?: string;
  /**
   * The name that the device integration (Device Handler or SmartApp) defines for the device.
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "color.light.100x"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device manufacturer name.
   * @example "SmartThings"
   */
  manufacturerName: string;
  /**
   * The device model.
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * An non-unique id that is used to help drive UI information.
   * @example "VD-STV_2018_K"
   */
  presentationId: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The ID of the Room with which the device is associated. If the device is not associated with any room, then this field will be null.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /** The IDs of all locations this device is shared with. */
  sharedLocations?: SharedLocation[];
  /** The IDs of all compenents on the device. */
  components?: DeviceComponent[];
  /** The time when the device was created at. */
  createTime?: string;
  healthState?: IdLessHealthState;
  /** The id of the Parent device. */
  parentDeviceId?: string;
  /** Device details for all child devices of the device. */
  childDevices?: ChildDeviceRef[];
  profile?: DeviceProfileReference;
  /** Device Profile information for a SmartApp. This field will be empty if device type is not ENDPOINT_APP. */
  app?: AppDeviceDetails;
  /** Bluetooth device information. This field will be empty if device type is not BLE. */
  ble?: BleDeviceDetails;
  /** Bluetooth device to device information. This field will be empty if device type is not BLE_D2D. */
  bleD2D?: BleD2DDeviceDetails;
  /** Device Profile information for DTH. This field will be empty if device type is not DTH. */
  dth?: DthDeviceDetails;
  /** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
  lan?: LanDeviceDetails;
  /** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
  zigbee?: ZigbeeDeviceDetails;
  /** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
  zwave?: ZwaveDeviceDetails;
  /** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
  matter?: MatterDeviceDetails;
  /** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
  edgeChild?: EdgeChildDeviceDetails;
  /** HUB device information. This field will be empty if the device type is not HUB. */
  hub?: HubDeviceDetails;
  /** MOBILE device information. This field will be empty if the device type is not MOBILE. */
  mobile?: MobileDeviceDetails;
  /** IR device information. This field will be empty if device type is not IR. */
  ir?: IrDeviceDetails;
  /** IR_OCF device information. This field will be empty if device type is not IR_OCF. */
  irOcf?: IrDeviceDetails;
  /** OCF device information. This field will be empty if device type is not OCF. */
  ocf?: OcfDeviceDetails;
  /** Viper device information. This field will be empty if device type is not VIPER. */
  viper?: ViperDeviceDetails;
  /** Group device information. This field will be empty if device type is not GROUP. */
  group?: GroupDeviceDetails;
  /** Virtual device information. This field will be empty if device type is not VIRTUAL. */
  virtual?: VirtualDeviceDetails;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type: DeviceIntegrationType;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * *DEPRECATED* please use `presentationId`
   * Vendor id of the device, used for UI.
   */
  vid?: string;
  /**
   * *DEPRECATED* please use `manufacturerName`
   * Manufacturer model number, used for UI.
   */
  mnmn?: string;
  /** The OCF device type (resource), used for UI. */
  ocfDeviceType?: string;
  /** Restriction tier of the device, if any. */
  restrictionTier: number;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:devices - the user can change device details
   *   <li> w:devices:locationId - the user can move the device from a location
   *   <li> w:devices:roomId - the user can move or remove the device from a room
   *   <li> x:devices - the user can execute commands on the device
   *   <li> d:devices - the user can uninstall the device
   *   </ul>
   * @uniqueItems true
   */
  allowed?: 'w:devices' | 'w:devices:locationId' | 'w:devices:roomId' | 'x:devices' | 'd:devices';
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
}

/**
 * The type of device integration.
 * All types besides ENDPOINT_APP will have profile populated.
 * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
 * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
 * If the type is IR, the details are in the "ir" field.
 * If the type is IR_OCF, the details are in the "irOcf" field.
 * If the type is VIPER, the details are in the "viper" field.
 */
export enum DeviceIntegrationType {
  APP = 'APP',
  BLE = 'BLE',
  BLED2D = 'BLE_D2D',
  DTH = 'DTH',
  ENDPOINT_APP = 'ENDPOINT_APP',
  GROUP = 'GROUP',
  HUB = 'HUB',
  IR = 'IR',
  IR_OCF = 'IR_OCF',
  LAN = 'LAN',
  MATTER = 'MATTER',
  MOBILE = 'MOBILE',
  MQTT = 'MQTT',
  OCF = 'OCF',
  PENGYOU = 'PENGYOU',
  SHP = 'SHP',
  VIDEO = 'VIDEO',
  VIPER = 'VIPER',
  VIRTUAL = 'VIRTUAL',
  WATCH = 'WATCH',
  ZIGBEE = 'ZIGBEE',
  ZWAVE = 'ZWAVE',
  EDGE_CHILD = 'EDGE_CHILD',
}

export interface AppDeviceDetails {
  /**
   * The ID of the installed app that integrates this device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  installedAppId?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  profile?: DeviceProfileReference;
}

export type BleDeviceDetails = object;

export interface BleD2DDeviceDetails {
  /**
   * Security encryption key.
   * @example "96012869B606355A1F843B1E19DC31B1"
   */
  encryptionKey?: string;
  /**
   * Key for the decrypt.
   * @example "BMO_256-CBS-PKMS1Padding"
   */
  cipher?: string;
  /**
   * BLE Advertising Id.
   * @example "9C0D4219"
   */
  advertisingId?: string;
  /**
   * Unique device identifier.
   * @example "88-57-1d-0e-53-ab"
   */
  identifier?: string;
  configurationVersion?: string;
  /** @example "https://apisa.samsungiots.com/v1/miniature/profile/e524ceba-93b9-499d-a90a-24214f7f01cb" */
  configurationUrl?: string;
  metadata?: object;
}

export interface DeviceProfileReference {
  /**
   * The device profile Id
   * @example "a7b3c264-2d22-416e-bca1-ca4b59a60aee"
   */
  id?: string;
}

export interface DthDeviceDetails {
  /** True if the device setup has been completed so the device is ready to use. */
  completedSetup: boolean;
  /** The device network type. */
  deviceNetworkType?: DeviceNetworkType;
  /**
   * The identifier for the device's DeviceType.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  deviceTypeId: string;
  /**
   * The name for the device's DeviceType.
   * @example "x.com.samsung.da.fridge"
   */
  deviceTypeName: string;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * The ID of the installed groovy application
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "8f5ra619-4c05-4a90-a245-cc129b0a8098"
   */
  installedGroovyAppId?: string;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
}

/**
 * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
 * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
 * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
 * @default "UNKNOWN"
 */
export enum DeviceNetworkSecurityLevel {
  UNKNOWN = 'UNKNOWN',
  ZWAVE_LEGACY_NON_SECURE = 'ZWAVE_LEGACY_NON_SECURE',
  ZWAVES0LEGACY = 'ZWAVE_S0_LEGACY',
  ZWAVES0FALLBACK = 'ZWAVE_S0_FALLBACK',
  ZWAVES2UNAUTHENTICATED = 'ZWAVE_S2_UNAUTHENTICATED',
  ZWAVES2AUTHENTICATED = 'ZWAVE_S2_AUTHENTICATED',
  ZWAVES2ACCESSCONTROL = 'ZWAVE_S2_ACCESS_CONTROL',
  ZWAVES2FAILED = 'ZWAVE_S2_FAILED',
  ZWAVES0FAILED = 'ZWAVE_S0_FAILED',
  ZWAVES2DOWNGRADE = 'ZWAVE_S2_DOWNGRADE',
  ZWAVES0DOWNGRADE = 'ZWAVE_S0_DOWNGRADE',
}

/** True if the device is executing locally on the hub */
export type ExecutingLocally = boolean;

/** object to query device components status */
export interface DeviceStatusQuery {
  components?: Record<string, ComponentStatusQuery>;
  healthState?: any;
}

/** object to query component capabilities status */
export interface ComponentStatusQuery {
  capabilities?: Record<string, CapabilityStatusQuery>;
}

/** object to query capability attributes status */
export interface CapabilityStatusQuery {
  attributes?: string[];
}

export interface IrDeviceDetails {
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId?: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCode?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /** list of child devices */
  childDevices?: IrDeviceDetails[];
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
}

export interface OcfDeviceDetails {
  /** OCF device type */
  ocfDeviceType?: string;
  /** Name of the device */
  name?: string;
  /** OCF spec version */
  specVersion?: string;
  /** OCF vertical domain spec version */
  verticalDomainSpecVersion?: string;
  /** OCF manufacturer name */
  manufacturerName?: string;
  /** OCF model number */
  modelNumber?: string;
  /** OCF platform version */
  platformVersion?: string;
  /** OCF platform OS */
  platformOS?: string;
  /** OCF platform H/W version */
  hwVersion?: string;
  /** OCF firmware version */
  firmwareVersion?: string;
  /** OCF vendor ID */
  vendorId?: string;
  /** OCF vendor resource client/server version */
  vendorResourceClientServerVersion?: string;
  /** Language code */
  locale?: string;
  /** The time when the device is signed up lastly */
  lastSignupTime?: string;
}

/** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
export interface LanDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
export interface ZigbeeDeviceDetails {
  /** The EUID of the Zigbee device */
  eui?: DeviceEui;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/**
 * 16-bit manufacturer identifier assigned by the Z-Wave Specification
 * @min 0
 * @max 65535
 * @example 134
 */
export type ZWaveManufacturerId = number;

/**
 * 16-bit manufacturer defined product type
 * @min 0
 * @max 65535
 * @example 17488
 */
export type ZWaveProductType = number;

/**
 * 16-bit manufacturer defined product identifier
 * @min 0
 * @max 65535
 * @example 12336
 */
export type ZWaveProductId = number;

/** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
export interface ZwaveDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** 16-bit manufacturer identifier assigned by the Z-Wave Specification */
  manufacturerId?: ZWaveManufacturerId;
  /** 16-bit manufacturer defined product type */
  productType?: ZWaveProductType;
  /** 16-bit manufacturer defined product identifier */
  productId?: ZWaveProductId;
}

/** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
export interface MatterDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** Vendor-supplied unique identifier. Optional. */
  uniqueId?: string;
  /** 16-bit vendor id. Optional. */
  vendorId?: number;
  /** 16-bit product id. Optional. */
  productId?: number;
  /** Listening type for the device. Optional. */
  listeningType?: MatterListeningType;
  /** List of network interfaces. Optional. */
  supportedNetworkInterfaces?: MatterNetworkInterfaces;
  /** Hardware and Software version info for matter devices. Optional. */
  version?: MatterVersion;
  /** Available Matter endpoints */
  endpoints?: MatterEndpoints;
  /** Determines whether or not to sync the child device's driver from its parent. Default is true. */
  syncDrivers?: SyncDrivers;
}

/** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
export interface EdgeChildDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The identifier assigned to this edge child device by its parent */
  parentAssignedChildKey?: ParentAssignedChildKey;
}

/** The network-specific identifier of the device on the network */
export type DeviceNetworkId = string;

/**
 * The identifier for the Device instance.
 * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
 */
export type DeviceId = string;

/**
 * The EUID of the Zigbee device
 * @example "24FD5B000105DB96"
 */
export type DeviceEui = string;

/**
 * The device network type.
 * @example "ZIGBEE"
 */
export type DeviceNetworkType = string;

/**
 * The ID of the Sprocket driver
 * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
 * @example "9314a926-528c-403f-ae56-4b0d059381dd"
 */
export type DriverId = string;

/** Listening type for the device. Optional. */
export enum MatterListeningType {
  ALWAYS = 'ALWAYS',
  SLEEPY = 'SLEEPY',
}

/** Hardware and Software version info for matter devices. Optional. */
export interface MatterVersion {
  /**
   * 16-bit hardware version. Optional.
   * @min 0
   * @max 65535
   * @example 771
   */
  hardware?: number;
  /** Label for the hardware version. Optional. */
  hardwareLabel?: string;
  /**
   * 32-bit software version. Optional.
   * @min 0
   * @max 4294967295
   * @example 50529027
   */
  software?: number;
  /** Label for the hardware version. Optional. */
  softwareLabel?: string;
}

/** List of network interfaces. Optional. */
export type MatterNetworkInterfaces = MatterNetworkInterface[];

/** Supported Network Interfaces of the Device */
export enum MatterNetworkInterface {
  THREAD = 'THREAD',
  WIFI = 'WIFI',
  ETHERNET = 'ETHERNET',
}

/** Available Matter endpoints */
export type MatterEndpoints = MatterEndpoint[];

/** Matter device endpoint */
export interface MatterEndpoint {
  /**
   * 16-bit identifier for the endpoint
   * @min 0
   * @max 65535
   * @example 771
   */
  endpointId?: number;
  /** List of device types for the endpoint */
  deviceTypes?: MatterEndpointDeviceType[];
}

/** Device type for a matter endpoint */
export interface MatterEndpointDeviceType {
  /**
   * 32-bit identifier for the device type
   * @min 0
   * @max 4294967295
   * @example 197379
   */
  deviceTypeId?: number;
}

/**
 * Determines whether or not to sync the child device's driver from its parent. Default is true.
 * @example true
 */
export type SyncDrivers = boolean;

/** The identifier assigned to this edge child device by its parent */
export type ParentAssignedChildKey = string;

/**
 * The hub that the device is connected to.
 * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
 */
export type HubId = string;

/** Provisioning type for a widget device */
export enum ProvisioningState {
  PROVISIONED = 'PROVISIONED',
  TYPED = 'TYPED',
  DRIVER_SWITCH = 'DRIVER_SWITCH',
  NONFUNCTIONAL = 'NONFUNCTIONAL',
}

/**
 * The location of a device on a floorplan map, if any.
 * @example {"coordinates":["1.0","2.0","3.0"],"rotation":["0","0","0"],"visible":true,"data":[{"extraData1":"some data"}]}
 */
export interface IndoorMap {
  /**
   * The coordinates to be used to map the device.
   * @maxItems 3
   * @minItems 3
   */
  coordinates?: number[];
  /**
   * The rotational data for the device.
   * @maxItems 3
   * @minItems 3
   */
  rotation?: number[];
  /** Whether or not the device is visible on the map. */
  visible?: boolean;
  /** Key value pairs to place additional information. */
  data?: Record<string, any>;
}

/** MOBILE device information. This field will be empty if the device type is not MOBILE. */
export type MobileDeviceDetails = object;

export interface HubDriver {
  /** The version of the driver revision being returned */
  driverVersion?: string;
  /**
   * The identifier of the Sprocket driver
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  driverId: string;
  /**
   * The identifier of the Sprocket channel
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  channelId?: string;
}

/**
 * Possible Values for Hub Characteristic "Availability" flags
 * @example "Available"
 */
export enum AvailabilityCharacteristic {
  Available = 'Available',
  Unavailable = 'Unavailable',
  Unsupported = 'Unsupported',
}

/**
 * Describes state of Zigbee OTA.
 * @default "DISABLED"
 */
export enum ZigbeeOta {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  ENABLED_WITH_LIGHTS = 'ENABLED_WITH_LIGHTS',
}

export interface ChildDeviceRef {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  id?: string;
}

export interface SharedLocation {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  locationId?: string;
}

export interface ViperDeviceDetails {
  /** @example "1a-74" */
  uniqueIdentifier?: string;
  /** @example "TP-Link" */
  manufacturerName?: string;
  /** @example "HS101" */
  modelName?: string;
  /** @example "23.123.231" */
  swVersion?: string;
  /** @example "v1 US bulb" */
  hwVersion?: string;
  /** @example "viper_bb238c20-675a-11ed-970f-571777eb58c5" */
  endpointAppId?: string;
}

/** An array of devices in the group */
export interface DeviceGroupDevice {
  /**
   * GUID representing the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "747d79d3-4685-4852-89b6-e2fc681a590f"
   */
  deviceId: string;
  /** Components to add to the group */
  components?: {
    /** @example "main" */
    id?: string;
    [key: string]: any;
  }[];
}

export interface VirtualDeviceDetails {
  /** Name of the device */
  name?: string;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  commandMappings?: CommandMappings;
}

export interface CommandMappings {
  commands?: CommandMapping[];
}

/**
 * A mapping of `commandName` to `attribute.value` that will allow users to support complex commands that would otherwise
 * not be determinable simply by the capabililty contract.
 */
export interface CommandMapping {
  /** The Capability ID. */
  capabilityId: string;
  /** The Capability version number. */
  version: number;
  /** The command name to apply the mapping to on the device */
  command: string;
  /** A collection of attribute values, replicator will use these to create device events in serial for the specified command. */
  eventValues: AttributeValue[];
}

/** The description of an attribute value that will be used to populate an event. */
export interface AttributeValue {
  /** The attribute that this command will correspond to */
  attribute?: string;
  /** How will the attribute be provided? Choose either to provide it with a command at runtime or to provide a set value here. */
  inputType?: 'STATIC' | 'ARGUMENT';
  /** The argument to be used automatically for this command mapping. Any simple type is accepted. */
  staticValue?: object;
}

export interface PagedDeviceComponents {
  items?: DeviceComponent[];
  _links?: Links;
}

export interface UpdateDeviceComponent {
  /** @example "main" */
  id: string;
  /**
   * The label for the device component.
   * @minLength 1
   * @maxLength 255
   * @example "Living room light switch 2"
   */
  label?: string;
  /**
   * Identifier allowing the user to pick a custom icon for the device component.
   * The icon of the main component represents the device itself
   * @minLength 1
   * @maxLength 255
   */
  icon?: string;
  /**
   * A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). Allows the user to redefine the category of the device from what the manufacturer set by default.
   * @maxItems 1
   * @minItems 1
   */
  categories: string[];
}

/** @example {"label":"Living room light","locationId":"0c0b935d-0616-4441-a0bf-da7aeec3dc0a","roomId":"0fd2b1ef-1b33-4a54-9153-65aca91e9660","components":[{"id":"main","label":"living room light switch 2","icon":"string","categories":["Light"]}],"indoorMap":{"coordinates":[1,2,3],"rotation":[0,0,0],"visible":true}} */
export interface UpdateDeviceRequest {
  /**
   * The label for the Device.
   * @minLength 1
   * @maxLength 255
   * @example "Living room light"
   */
  label?: string;
  /**
   * The ID of the Location where the Device should be moved to.
   * Not all Devices support Location moves.
   * Moving between some Locations may be rejected depending on the data region used.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The ID of the Room with which to associate the Device is associated.
   * The Room must be valid for the Location of the Device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  components?: UpdateDeviceComponent[];
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
}

/** HUB device information. This field will be empty if the device type is not HUB. */
export interface HubDeviceDetails {
  /**
   * The unique identifier for this manufactured hub.
   * @format ^[0-9A-F]{16}$
   * @example "D053A8B4F6D80001"
   */
  hubEui: string;
  /**
   * The hub's firmware version
   * @format ^[0-9]\.[0-9]\.[0-9]{3}$
   * @example ""
   */
  firmwareVersion: string;
  /** A list of drivers installed on the hub */
  hubDrivers: HubDriver[];
  hubData: {
    /**
     * Zwave static DSK for the hub.
     * @example "21720-31296-41384-03009-58023-25366-38831-43982"
     */
    zwaveStaticDsk?: string;
    /** Whether zwaveS2 is enabled for this hub. */
    zwaveS2: boolean;
    /**
     * The hardwareType for this hub
     * @example "V3_HUB"
     */
    hardwareType: string;
    /**
     * The hub's hardware ID
     * @example "00A2"
     */
    hardwareId?: string;
    /**
     * The Zigbee firmware version for this hub
     * @example "5.4.0"
     */
    zigbeeFirmware?: string;
    /** Whether the hub supports zigbee3 */
    zigbee3: boolean;
    /** Describes state of Zigbee OTA. */
    zigbeeOta?: ZigbeeOta;
    /** Indicates if Zigbee OTA is enabled. */
    otaEnable?: string;
    /** Whether the hub allows zigbee unsecure rejoin */
    zigbeeUnsecureRejoin: boolean;
    /** Possible Values for Hub Characteristic "Availability" flags */
    primarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    secondarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zigbeeAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zwaveAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    threadAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    lanAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    matterAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    localVirtualDeviceAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    childDeviceAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    edgeDriversAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    hubReplaceAvailability?: AvailabilityCharacteristic;
    /** The primary hub device id for this hub. Null/Empty if hub is not a repeater. */
    primaryHubDeviceId?: string;
    /** The Zigbee Channel of the Hub. */
    zigbeeChannel?: string;
    /** The Personal Area Network (PAN) id of the zigbee network the hub is on. */
    zigbeePanId?: string;
    /** The unique identifier for this manufactured hub. */
    zigbeeEui?: string;
    /** The short address of a node in Zigbee network. */
    zigbeeNodeID?: string;
    /** The address of a single node in the network */
    zwaveNodeID?: string;
    /** The common identification of all nodes belonging to one logical Z-Wave network */
    zwaveHomeID?: string;
    zwaveSucID?: string;
    zwaveVersion?: string;
    /** The global region this zwave radio is operating in. */
    zwaveRegion?: string;
    /** MAC address of the hubs network interface. */
    macAddress?: string;
    /** IP address of the hub. */
    localIP?: string;
    /** Whether the hub is zigbee radio functional. */
    zigbeeRadioFunctional?: boolean;
    /** Whether the hub is zwave radio functional. */
    zwaveRadioFunctional?: boolean;
  };
}

export interface DeviceComponent {
  /**
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @example "main"
   */
  id: string;
  /** UTF-8 label for the component. */
  label?: string;
  capabilities: DeviceCapabilityReference[];
  /** Defines the categories for the device. There can be up to 2, one defined by the manufacturer the other is a user selected value. */
  categories: DeviceCategory[];
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
  /** A user selected icon value */
  icon?: string;
}

export interface CapabilityConfiguration {
  values: CapabilityConfigurationValue[];
}

export interface CapabilityConfigurationValue {
  /**
   * The path to the preference attribute that is being configured.
   * @example "thermostatMode.value"
   */
  key: string;
  /**
   * The range of values supported by the capability attribute. The range must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @maxItems 2
   * @minItems 2
   * @example "[1, 50]"
   */
  range?: number[];
  /**
   * The list of enumerated values that are supported for the capability attribute. The list of supported value must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @example "[ "cooling", "fan only", "heating", "idle" ]"
   */
  enabledValues?: string[];
  /**
   * The incremental step that increases or decreases for numeric values.
   * @format double
   * @default 1
   */
  step?: number;
}

export interface BaseCapabilityReference {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

export type CapabilityReferenceRequest = BaseCapabilityReference & {
  config?: CapabilityConfiguration;
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
};

export type CapabilityReference = CapabilityReferenceRequest & {
  /** @example false */
  ephemeral?: boolean;
};

export type DeviceCapabilityReference = CapabilityReference & {
  /** A map of Attribute name to Attribute state. */
  status?: CapabilityStatus;
};

/** The status of a Device. */
export interface DeviceStatus {
  /**
   * A map of componentId to Component status.
   * @example {"main":{"switch":{"switch":{"value":"on"}},"switchLevel":{"level":{"value":90}}}}
   */
  components?: Record<string, ComponentStatus>;
  healthState?: {
    /** Current state of the device */
    state?: 'ONLINE' | 'OFFLINE';
    /**
     * Last reported date/time in UTC
     * @format date-time
     */
    lastUpdatedDate?: string;
  };
}

/**
 * A map of capabilityId to Capability status.
 * @example {"switch":{"switch":{"value":"on"}},"switchLevel":{"level":{"value":90}}}
 */
export type ComponentStatus = Record<string, CapabilityStatus>;

/**
 * A map of Attribute name to Attribute state.
 * @example {"switch":{"value":"on"}}
 */
export type CapabilityStatus = Record<string, AttributeState>;

export interface AttributeState {
  /** @example 0 */
  value?: object;
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

/** @example {"component":"main","capability":"switchLevel","attribute":"level","value":0,"unit":null,"data":null} */
export interface DeviceStateEvent {
  /** The name of the component on this device, default is 'main'. */
  component?: string;
  /** Capability that this event relates to. */
  capability?: string;
  /** Name of the capability attribute that this event relates to. */
  attribute?: string;
  /** Value associated with the event. The valid value depends on the capability. */
  value: object;
  /** Unit of the value field. */
  unit?: string;
  /** Key value pairs about the state of the device. Valid values depend on the capability. */
  data?: Record<string, object>;
  /** The id on the command that triggered this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
}

export interface CreateBackendEventsResponse {
  /** The list of state changes for each event created in the order in the create request */
  stateChanges?: boolean[];
}

export type CreateDeviceEventsResponse = object;

export interface DeviceCommandsResponse {
  results?: CommandResult[];
}

export interface CommandResult {
  /**
   * A UUID used for tracking the individual command.
   * @format uuid
   */
  id?: string;
  /**
   * `ACCEPTED`: the command is processing but it's outcome is unknown
   * `COMPLETED`: the command has successfully completed
   * `FAILED`: the command has failed
   */
  status?: CommandStatus;
}

/**
 * `ACCEPTED`: the command is processing but it's outcome is unknown
 * `COMPLETED`: the command has successfully completed
 * `FAILED`: the command has failed
 */
export enum CommandStatus {
  ACCEPTED = 'ACCEPTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type CreateBatchDeviceCommandsResponse = object;

export interface BackendInstallRequest {
  /**
   * The id that should be used for the device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  deviceId?: string;
  /**
   * The owner id of the device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  ownerId?: string;
  /**
   * The name that the device integration defines for the device.
   * @minLength 1
   * @maxLength 255
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The display label for the device.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @maxLength 255
   */
  label?: string;
  /** The location id that the device will be installed on. */
  locationId: string;
  /**
   * The id of the parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /** The device profile id that describes the components and capabilities. */
  profileId: string;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /**
   * The device manufacturer code.
   * @maxLength 255
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device model.
   * @maxLength 255
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * Key that is used to chose the base url for requests from Gizmo to the backend.
   * @example "eu"
   */
  routingKey?: string;
  /**
   * Room containing this device
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  roomId?: string;
  components?: {
    /** @example "main" */
    id: string;
    /** @example "main" */
    label?: string;
    /**
     * A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories).
     * @maxItems 1
     * @minItems 1
     */
    categories: string[];
  }[];
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * Key value pairs stored in the conductor for the device.
   * These are returned with requests to the backend.
   */
  metadata?: Record<string, object>;
  /** A value that will need to be included in update and event requests in the 'X-ST-DEVICE-SECRET' header */
  secret?: string;
  /** Optional - the definition of the device profile that this device should use. */
  deviceProfileOverride?: DeviceProfile;
}

export interface BackendUpdateRequest {
  /**
   * The owner id of the device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  ownerId?: string;
  /** The device profile id that describes the components and capabilities. */
  profileId?: string;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /**
   * The device manufacturer code.
   * @minLength 1
   * @maxLength 255
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device model.
   * @maxLength 255
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * The name that the device integration defines for the device.
   * @minLength 1
   * @maxLength 255
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @minLength 0
   * @maxLength 255
   * @example "My light"
   */
  label?: string;
  components?: {
    /** @example "main" */
    id: string;
    /** @example "main" */
    label?: string;
  }[];
  /**
   * Key that is used to chose the base url for requests from Gizmo to the backend.
   * @example "eu"
   */
  routingKey?: string;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type?: DeviceIntegrationType;
  /** The parent to associate the device with. This is primarily for migration of devices. */
  parentDeviceId?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * Key value pairs stored in the conductor for the device.
   * These are returned with requests to the backend.
   */
  metadata?: Record<string, any>;
  /** A value that will need to be included in update and event requests in the 'X-ST-DEVICE-SECRET' header */
  secret?: string;
  /** Optional - the definition of the device profile that this device should use. */
  deviceProfileOverride?: DeviceProfile;
}

export interface PagedBackendDevices {
  items?: BackendDevice[];
  _links?: Links;
}

export interface BackendDevice {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId?: string;
  /**
   * The identifier for the owner of the device instance.
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId?: string;
  /**
   * The name that the device integration (Device Handler or SmartApp) defines for the device.
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "My light"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device model.
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The ID of the Room with which the device is associated. If the device is not associated with any room, then this field will be null.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /**
   * The identifier for the parent device.
   * @example "40cad82b-61a5-4bd8-9161-b06bf51525e7"
   */
  parentDeviceId?: string;
  /** Device ids for all child devices of the device. */
  childDeviceIds?: string[];
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type?: DeviceIntegrationType;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  profileId: string;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /**
   * Key that is used to chose the base url for requests from Gizmo to the backend.
   * @example "eu"
   */
  routingKey?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * Key value pairs that were stored in the conductor for the device.
   * If the metadata contains a "public" key that will be included in the details based on the backend type through
   * the public API, only keys that are defined in the swagger will be populated.
   * If "mnmn", "vid", "ocfDeviceType" keys are present they will override values from the device profile.
   * If the metadata includes "deviceNetworkId" it will be synchronized to DM.
   */
  metadata?: Record<string, object>;
}

export interface BackendDeviceEventsRequest {
  /**
   * An array of attribute state updates.
   * @maxItems 8
   * @minItems 1
   */
  deviceEvents?: DeviceEvent[];
}

export interface DeviceEvent {
  /** @example "main" */
  componentId?: string;
  /** @example "switch" */
  capability?: string;
  /** @example "switch" */
  attribute?: string;
  /** The id on the command that trigged this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
  state?: AttributeState;
  visibility?: EventVisibilityData;
  providerData?: DeviceEventProviderData;
}

export interface EventVisibilityData {
  /**
   * Indicates whether the event should be displayed in the history feed.
   * This is used because some device attributes are very chatty.
   */
  displayed?: boolean;
  /**
   * Indicates if the event cannot be stored for longer than the standard 7 day recent history.
   * This can be based on legal obligations.
   */
  nonArchivable?: boolean;
  /**
   * Indicates whether the event history should be stored in recent history (7 days).
   * This can be based on legal obligations.
   */
  ephemeral?: boolean;
}

export interface DeviceEventProviderData {
  /**
   * The UNIX time that the event occured according to the provider.
   * @format int64
   */
  timestamp?: number;
  /**
   * An increasing 64 bit (long) number that represents an ordering of events from the producer.
   * Higher numbers represent more recent events. If this is provided it will be taken into
   * consideration in state change determination but will not affect broadcast of the event.
   * There may be gaps in the sequence.
   * @format int64
   * @example 797606
   */
  sequenceNumber?: number;
  /**
   * A foreign event id used to correlate logs.
   * @maxLength 36
   */
  eventId?: string;
  /**
   * If the provider knows if the event represents a state change they may signal that.
   * Even if the event is not considered a state change from the provider the state of the device
   * may be updated if it is out of sync.
   * @default "UNKNOWN"
   */
  stateChange: 'Y' | 'N' | 'UNKNOWN';
  /**
   * Event data that is not translated into SmartThings capabilities.
   * @maxLength 1000
   */
  rawData?: string;
}

/**
 * the status of the requested device group
 * @example {"deviceGroupId":"457d79d1-4685-4852-89b6-e2fc681a590f","devices":{"dev1":{"components":{"main":{"switch":{"switch":{"value":["on"]}}}}},"dev2":{"components":{"subComponent":{"switch":{"switch":{"value":["off"]}}}}}},"groupAggregate":{"switch":{"switch":{"value":["off"]}}}}
 */
export interface DeviceGroupStatusResponse {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  deviceGroupId?: string;
  devices?: Record<
    string,
    {
      /**
       * A map of componentId to Component status.
       * @example {"main":{"switch":{"switch":{"value":"on"}},"switchLevel":{"level":{"value":90}}}}
       */
      components?: Record<string, ComponentStatus>;
      healthState?: {
        /** Current state of the device */
        state?: 'ONLINE' | 'OFFLINE';
        /**
         * Last reported date/time in UTC
         * @format date-time
         */
        lastUpdatedDate?: string;
      };
    }
  >;
  groupAggregate?: Record<string, Record<string, AttributeState>>;
}

export interface InternalDevice {
  /**
   * the device id
   * @example "51b5dc55-f856-49cd-bf89-da6f54e244b2"
   */
  id: string;
  /**
   * The name that the device integration (Device Handler or SmartApp) defines for the device.
   * @example "color.light.100x"
   */
  name: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "Joe's room light"
   */
  label: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device model.
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * Used to communicate a unique identifier to DM so that things like the Alexa integration can recognize the
   * uniqueness of the device. We are using this field because it exists in DM and is not used by profile based
   * devices yet.
   */
  deviceNetworkId?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  mnmn?: string;
  /**
   * The User UUID for the owner of the device when applicable
   * @format uuid
   */
  ownerId?: string;
  vid?: string;
  ocfDeviceType?: string;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type: DeviceIntegrationType;
  /**
   * Device creation time (since epoch)
   * @format int64
   * @example 1634226746547
   */
  dateCreated?: number;
  /**
   * the external id for the device (foreign system id)
   * @example "switch-123"
   */
  externalId?: string;
  /**
   * the installed app id (owner) for ENDPOINT_APP device type
   * @example "f7239728-edb3-48e9-b588-a27f30b968a9"
   */
  installedAppId?: string;
  /**
   * the device profile id if applicable for the device type
   * @example "f7239728-edb3-48e9-b588-a27f30b968a9"
   */
  profileId?: string;
  /**
   * the Groovy installed app id for DTH device type
   * @example "f7239728-edb3-48e9-b588-a27f30b968a9"
   */
  installedGroovyAppId?: string;
  /** a list of components for DTH (non profile) type devices */
  components?: {
    /** @example "main" */
    id?: string;
    /** @example "comp1" */
    label?: string;
    /**
     * The identifier for the device's DeviceType.
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
     */
    deviceTypeId?: string;
  }[];
  /**
   * The name for the device's DeviceType for DTH type devices.
   * @example "x.com.samsung.da.fridge"
   */
  deviceTypeName?: string;
  /**
   * The device network type if applicable for DTH type devices.
   * @example "ZWAVE"
   */
  deviceNetworkType?: string;
  /**
   * The hub that the device is connected to.
   * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
   */
  hubId?: string;
  /** True if the device is executing locally on the hub */
  executingLocally?: boolean;
  /**
   * The room of the device.
   * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
   */
  roomId?: string;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel: DeviceNetworkSecurityLevel;
  /** True if the device setup has been completed so the device is ready to use. */
  completedSetup?: boolean;
  /**
   * A value that will need to be included in update and event requests in the 'X-ST-DEVICE-SECRET' header to Gizmo.
   * This will be used in the migration to Peddler for device events and should be a key for the Hub so only that
   * can cause updates to the device.
   */
  secret?: string;
  /**
   * The id of this device's parent.
   * @example "f7239728-edb3-48e9-b588-a27f30b968a9"
   */
  parentDeviceId?: string;
}

export interface InternalCommands {
  actor?: {
    actorType?: 'GROOVY_APP' | 'USER';
    groovyApp?: {
      installedAppId?: string;
    };
    user?: {
      clientId?: string;
      userId?: string;
    };
  };
  commands?: DeviceCommand[];
}

export type JsonObject = Record<string, object>;

export type DeleteDeviceCommandsResponse = object;

export interface PagedDeviceCategories {
  items?: DeviceCategoryDetails[];
  _links?: Links;
}

/** A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). */
export interface DeviceCategoryDetails {
  /** @example "Light" */
  name: string;
  /** @example "oic.d.light" */
  resourceType: string;
}

/** A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). */
export interface DeviceCategory {
  /** @example "Light" */
  name: string;
  /** @default "manufacturer" */
  categoryType: 'manufacturer' | 'user';
}

export interface GroupDeviceDetails {
  /** @example "My Group" */
  groupName?: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  devices?: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "747d79d3-4685-4852-89b6-e2fc681a590f"
     */
    deviceId: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
}

/**
 * The type of the group in question
 *
 * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
 */
export enum DeviceGroupType {
  UNDETERMINED = 'UNDETERMINED',
  GENERIC = 'GENERIC',
  VIDEO_CAMERA = 'VIDEO_CAMERA',
  LIGHTING = 'LIGHTING',
}

/** @example {"groupName":"helloWorldGroup","deviceGroupId":"457d79d1-4685-4852-89b6-e2fc681a590f","devices":{"30d3691f-2416-4cbc-b193-2329581f300d2":{"components":{"main":{"switch":{"switch":{"value":["on"]}}}}},"30d7421f-2416-4cbc-b193-2329581f29d1":{"components":{"subComponent":{"switch":{"switch":{"value":["off"]}}}}}},"groupAggregate":{"switch":{"switch":{"value":["off"]}}}} */
export interface DeviceGroupStatusGizmoResponse {
  /** Name of the group created */
  groupName?: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  deviceGroupId?: string;
  devices?: Record<string, DeviceStatus>;
  groupAggregate?: Record<string, CapabilityStatus>;
}

/** A group */
export interface DeviceGroupCreateRequest {
  /** Name of the group created */
  groupName: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group */
    components: {
      /** @example "main" */
      id?: string;
    }[];
  }[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
  /**
   * Indicates whether this group is a summary group. Summary groups do not emit events and do not calculate group state, but may be issued commands.
   * @default false
   */
  summaryGroup?: boolean;
}

/** A group */
export interface DeviceGroupUpdateRequest {
  /** Name of the group */
  groupName: string;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group */
    components: {
      /** @example "main" */
      id?: string;
    }[];
  }[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
}

/** A group */
export interface DeviceGroupResponse {
  /**
   * Name of the group created
   * @example "helloWorldGroup"
   */
  groupName: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType: DeviceGroupType;
  /**
   * Location where this group is
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  locationId?: string;
  /** restriction tier of the device group */
  restrictionTier?: number;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
     */
    deviceId?: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
  /**
   * a GUID that identifies a group
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  deviceGroupId: string;
  /** Lowest common denominator capability of all the devices in the group */
  deviceGroupCapabilities: DeviceGroupCapability[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
  /** Indicates whether this group is a summary group. Summary groups do not emit events and do not calculate group state, but may be issued commands. */
  summaryGroup: boolean;
}

/** A paginated array of device groups */
export interface PagedDeviceGroups {
  items?: DeviceGroupResponse[];
  _links?: Links;
}

/** @example {"switch":{"switch":{"value":"on","unit":null}}} */
export type DeviceAttributesPerCapability = Record<string, DeviceAttributes>;

/** @example {"switch":{"value":"on","unit":null}} */
export type DeviceAttributes = Record<string, AttributeData>;

export interface AttributeData {
  value?: object;
  unit?: string;
  data?: Record<string, any>;
}

export interface DeviceGroupCommandRequest {
  /** An array of commands to execute on the Device. */
  commands?: DeviceGroupCommand[];
}

/** @example {"capability":"switchLevel","command":"setLevel","arguments":[100,1]} */
export interface DeviceGroupCommand {
  capability?: string;
  command?: string;
  arguments?: object[];
}

export type DeviceGroupDeleteResponse = Record<string, any>;

export type DeviceGroupCommandResponse = Record<string, any>;

export type DeviceGroupUpdateDeviceRequest = Record<string, any>;

export type DeviceGroupDeleteDeviceResponse = Record<string, any>;

export type DeviceGroupUpdateDeviceResponse = Record<string, any>;

/** The capability that is common to all devices in the group */
export interface DeviceGroupCapability {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

/** Internal device group representation */
export interface InternalDeviceGroup {
  /**
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "457d79d1-4685-4852-89b6-e2fc681a590f"
   */
  deviceGroupId?: string;
  /** Name of the group created */
  groupName?: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
}

/**
 * An object to represent a device belonging to room.
 * @example {"deviceId":"30d3691f-2416-4cbc-b193-2329581f29d1"}
 */
export interface AddRoomDeviceInfo {
  /** @example "30d3691f-2416-4cbc-b193-2329581f29d1" */
  deviceId: string;
  /** Future field , currently not used (Device order within the room) */
  sortOrder?: number;
}

/** A request object to add devices to room */
export interface AddDevicesToRoomRequest {
  items: AddRoomDeviceInfo[];
}

/** A request object to update the device profile for a specific device */
export interface UpdateDeviceProfileRequest {
  /**
   * The updated device profile ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  profileId?: string;
}

/** @example {} */
export type AddDevicesToRoomResponse = object;

/** A request object to delete devices from room. */
export interface RemoveDevicesFromRoomRequest {
  devices: string[];
}

/** @example {} */
export type RemoveDevicesFromRoomResponse = object;

export interface PagedRoomDevices {
  items?: Device[];
  _links?: Links;
}

export type DeviceHealthResponse = DeviceHealthState & {
  /** @minItems 0 */
  children?: DeviceHealthState[];
};

export interface DeviceHealthState {
  /** Id of the device */
  deviceId: string;
  state: HealthState;
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate: string;
}

export interface InternalDeviceHealthRequest {
  /** Id of the device */
  deviceId?: string;
  state: HealthState;
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate?: string;
}

export interface UpdateDeviceHealthRequest {
  /**
   * Health state to set the root device to.
   * Can be null if descendants value provided, required otherwise.
   */
  state?: HealthState;
  /**
   * Flat list of state updates for descendants anywhere in the subtree.
   *
   * Use this to control the state of a subset of the children at once i.e. a radio is down.
   * Parent being offline still overrules child state.
   */
  descendants?: UpdateChildDeviceHealth[];
}

export interface UpdateChildDeviceHealth {
  deviceId: string;
  /** value to set child devices health state to */
  state: HealthState;
}

export enum HealthState {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export interface DeviceHealthEnrollmentResponse {
  /** The minimum number of seconds between pings to the device. Null when the device is not configured to be monitored. */
  checkInterval?: number;
  /**
   * Flat list of all descendants enrollment data. Only present if children requested.
   * @minItems 0
   */
  descendants?: DescendantDeviceHealthEnrollment[];
}

export interface DescendantDeviceHealthEnrollment {
  deviceId: string;
  /** The number of seconds between pings to the device. Null when the device is not configured to be monitored. */
  checkInterval?: number;
}

export interface DeviceIntegrationProfileKey {
  /**
   * Unique identifier for integration profile.
   * @format uuid
   */
  id: string;
  /**
   * Major Version of the integration profile (major.minor). When creating a minor version, only the major is required.
   * @format int64
   */
  majorVersion: number;
  /**
   * Minor Version of the integration profile (major.minor). When creating a minor version, only the major is required.
   * @format int64
   */
  minorVersion?: number;
  /**
   * @format uuid
   * @example "a362ddb6-349b-4650-9911-681b51069a57"
   */
  overrideProfileId?: string;
}

export type DeviceProfile = DeviceProfileResponse & {
  /** A typed model which provides information around ownership of a specific domain. */
  owner?: Owner;
};

export type DeviceProfileResponse = DeviceProfileBase &
  DeviceProfileMigrationStatus & {
    /**
     * The lifecycle status of a device profile.
     * 'DEVELOPMENT' - Device profile can be modified. The profile is only available to the developer and can only be used with a self-published app.
     * 'PUBLISHED' - Device profile can be shared with other users, but cannot be modified.
     */
    status?: DeviceProfileStatus;
    preferences?: PreferenceResponse[];
    components?: DeviceComponent[];
  };

export interface DeviceProfileBase {
  /** @example "a362ddb6-349b-4650-9911-681b51069a57" */
  id?: string;
  /** @example "thermostat1.model1" */
  name?: string;
  /** Additional information about the device profile, limited to 10 entries. */
  metadata?: DeviceProfileMetadata;
  /** The restriction to limit actions a device can take. */
  restrictions?: DeviceRestriction;
}

/**
 * Additional information about the device profile, limited to 10 entries.
 * @example {"firmWareVersion":"0.2.123","manufacturerName":"SmartThingsCommunity"}
 */
export type DeviceProfileMetadata = any;

/** The restriction to limit actions a device can take. */
export type DeviceRestriction = Restriction;

/** Describes the migration status (from v1 -> v2). This profile will be available in a backwards compatible fashion regardless. */
export interface DeviceProfileMigrationStatus {
  /** @default "NOT_MIGRATED" */
  migrationStatus: 'MIGRATED' | 'NOT_MIGRATED';
}

/**
 * The lifecycle status of a device profile.
 * 'DEVELOPMENT' - Device profile can be modified. The profile is only available to the developer and can only be used with a self-published app.
 * 'PUBLISHED' - Device profile can be shared with other users, but cannot be modified.
 * @default "DEVELOPMENT"
 */
export enum DeviceProfileStatus {
  DEVELOPMENT = 'DEVELOPMENT',
  PUBLISHED = 'PUBLISHED',
}

export type DeviceMigrationResponse = object;

export interface DeviceShareRequest {
  share?: DeviceShare[];
}

export interface DeviceShare {
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  shareType?: 'ADD' | 'REMOVE';
}

export type DeviceShareResponse = object;

/** An OCF device representation that matches the oic/p device representation */
export interface OcfDeviceProfile {
  /**
   * The label for the device
   * @minLength 1
   * @maxLength 255
   * @example "Living room light"
   */
  label?: string;
  /** @format uuid */
  deviceId?: string;
  /** Manufacturer's name */
  mnmn?: string;
  /** Vendor (model) ID */
  vid?: string;
  /** Manufacturer's code */
  mfc?: string;
  /** LocationId for the device */
  locationId?: string;
  /**
   * The User UUID for the owner of the device when applicable
   * @format uuid
   */
  ownerId?: string;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  deviceBackendType?: DeviceIntegrationType;
  /** The device network type */
  deviceNetworkType?: string;
  /** the room that the device is assigned to */
  roomId?: string;
  /** The DTH device type name. This should not be depended on! */
  deviceTypeName?: string;
  /** The DTH device type id. This should not be depended on! */
  deviceTypeId?: string;
  /** The profile Id that the device is using for non-DTH devices. This should not be depended on! It does not work for DIPs */
  deviceProfileId?: string;
  /** The OCF device type assigned to the device */
  ocfDeviceType?: string;
}

export interface PreferenceResponse {
  /** The ID of the preference */
  preferenceId?: string;
  /** An alphanumeric English language name for this preference. */
  name?: string;
  /**
   * A short description for this preference.
   * @example "Temperature Offset"
   */
  title: string;
  /**
   * A long description for this preference.
   * @example "The offset for a particular temperature setting"
   */
  description?: string;
  /**
   * A flag describing whether this property is required or not.
   * @default false
   */
  required?: boolean;
  /**
   * A flag describing whether this preference is explicit, or inline.
   * @default false
   */
  explicit?: boolean;
  /** The type of preference this is. */
  preferenceType: PreferenceType;
}

/**
 * The definition of this preference.
 * @example {"id":"example.colorSelect","name":"colorSelect","title":"Color Select","description":"Select a preset color","required":false,"preferenceType":"enumeration","definition":{"options":{"red":"Red","yellow":"Yellow","lightBlue":"Light Blue"},"default":"red"}}
 */
export type EnumerationPreference = PreferenceResponse & {
  definition: {
    /** The available selections for an `enumeration` preference. */
    options: Record<string, string>;
    /** Default value for a preference. */
    default?: any;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.notificationMessage","name":"notificationMessage","title":"Notification Message","description":"Set the text of the notification message","preferenceType":"string","definition":{"stringType":"text","minLength":1,"maxLength":10}}
 */
export type StringPreference = PreferenceResponse & {
  definition?: {
    /** Minimum length a string may be set to. */
    minLength?: number;
    /** Maximum length a string may be set to. */
    maxLength?: number;
    /**
     * The type of a string preference.
     * `text` is a normal preference, `password` encrypts the values, and `paragraph` is for documentation purposes.
     * @default "text"
     */
    stringType?: 'text' | 'password' | 'paragraph';
    /** Default value for a preference. */
    default?: string;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.tempOffset","name":"tempOffset","title":"Temperature Offset","description":"Set the default temperature offset of this device","required":false,"preferenceType":"integer","definition":{"minimum":-10,"maximum":10,"default":0}}
 */
export type IntegerPreference = PreferenceResponse & {
  definition?: {
    /** Minimum value a preference may be set to. */
    minimum?: number;
    /** Maximum value a preference may be set to. */
    maximum?: number;
    /** Default value for a preference. */
    default?: number;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.lightToggleDelay","name":"lightToggleDelay","title":"Light Toggle Delay","description":"The delay time to toggle a light to turn on or off","required":false,"preferenceType":"number","definition":{"minimum":0,"maximum":1,"default":0.5}}
 */
export type NumberPreference = PreferenceResponse & {
  definition?: {
    /**
     * Minimum value a preference may be set to.
     * @format double
     */
    minimum?: number;
    /**
     * Maximum value a preference may be set to.
     * @format double
     */
    maximum?: number;
    /**
     * Default value for a preference.
     * @format double
     */
    default?: number;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.featureEnabled","name":"featureEnabled","title":"Feature Enabled","description":"Set the feature to enabled for this device","required":false,"preferenceType":"boolean","definition":{"default":true}}
 */
export type BooleanPreference = PreferenceResponse & {
  definition?: {
    /** Default value for a preference. */
    default?: boolean;
  };
};

/** The type of preference this is. */
export enum PreferenceType {
  Integer = 'integer',
  Number = 'number',
  Boolean = 'boolean',
  String = 'string',
  Enumeration = 'enumeration',
}

export interface PreferenceValue {
  /** The type of preference this is. */
  preferenceType: PreferenceType;
}

export type IntegerPreferenceValue = PreferenceValue & {
  value: number;
};

export type NumberPreferenceValue = PreferenceValue & {
  value: number;
};

export type BooleanPreferenceValue = PreferenceValue & {
  value: boolean;
};

export type StringPreferenceValue = PreferenceValue & {
  value: string;
};

/** @example {"values":{"temperatureOffset":{"preferenceType":"integer","value":3},"example.lightToggleDelay":{"preferenceType":"number","value":0.68},"example.featureEnabled":{"preferenceType":"boolean","value":false},"example.notificationMessage":{"preferenceType":"string","value":"It is hot"},"example.colorSelect":{"preferenceType":"string","value":"lightBlue"}}} */
export interface DevicePreferenceResponse {
  /** Map of PreferenceId to its stored values */
  values?: Record<string, PreferenceValue>;
}

export type ExtendedDevicePreferenceResponse = DevicePreferenceResponse & {
  /** Map of PreferenceId to its definitions */
  definitions?: Record<string, PreferenceResponse>;
};

/** @example {"value":3} */
export interface UpdateDeviceParameterRequest {
  value: object;
}

export interface GetDevicesParams {
  /**
   * The device capabilities to filter the results by.
   * The capabilities are treated as an "and" so all capabilities must be present.
   */
  capability?: string[];
  /** The device locations to filter the results by. */
  locationId?: string[];
  /** The device ids to filter the results by. */
  deviceId?: string[];
  /**
   * Include the status of the device's capabilities where permission is adequate to view them.
   * This requires `r:devices` permission.
   */
  includeStatus?: boolean;
  /** Include the Health status of the device. This requires `r:devices` permission. */
  includeHealth?: boolean;
  /** The device types to filter the results by. */
  type?: string[];
  /** The device categories to filter the results by. */
  category?: string[];
  /**
   * Treat all capability filter query params as a logical "or" or "and" with a default of "and".
   * @default "and"
   */
  capabilitiesMode?: 'or' | 'and';
  /**
   * Restricted devices are hidden by default. This query parameter will reveal them. Device status will
   * not be provided if the token does not have sufficient access level to view the device status even
   * if includeStatus parameter is set to true.
   */
  includeRestricted?: boolean;
  /** Only list devices accessible by the given accessLevel. */
  accessLevel?: number;
  /**
   * User-level devices are devices that are not tied to a location, but are instead tied to the user. In order
   * to include these devices in the list, a flag is needed to differentiate from devices listed by location.
   */
  includeUserDevices?: boolean;
  /**
   * GROUP type devices are devices that represent Device Groups. In order to include these devices in the list,
   * a flag needs to be included.
   */
  includeGroups?: boolean;
  /** Use this in conjunction with includeUserDevices to get only User-level devices. */
  excludeLocationDevices?: boolean;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
}

export interface GetDeviceParams {
  /**
   * Include the status of the device's capabilities where permission is adequate to view them.
   * This requires `r:devices` permission.
   */
  includeStatus?: boolean;
  /** Expand the child device details nested in the device's description. */
  includeChildren?: boolean;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
  /** The device's id */
  deviceId: string;
}

export interface ExecuteDeviceCommandsParams {
  /** Specifies whether the command should be executed in order or asynchronously. */
  ordered?: boolean;
  /** The Device ID */
  deviceId: string;
}

export interface ListBackendDevicesParams {
  locationId: string[];
  /**
   * Limit the results to only devices that are children of the Id supplied.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  childOf?: string;
  /**
   * Works with childOf and limits how far from the parent the results can be.
   * 1 is direct children, 2 is children and their children
   * @min 1
   */
  childDepth?: number;
  backendType: string;
}

export interface GetBackendDeviceParams {
  /** Include devices that may have been recently deleted. */
  includeDeleted?: boolean;
  backendType: string;
  /** The Device ID */
  deviceId: string;
}

export interface GetDeviceHealthEnrollmentParams {
  /** Specifies if the enrollment data for descendants devices should be included in the response. */
  includeChildren?: boolean;
  backendType: string;
  /** The Device ID */
  deviceId: string;
}

export interface DeleteDeviceHealthEnrollmentParams {
  /** Specifies if the enrollment data for descendants devices should be included in the response. */
  includeChildren?: boolean;
  backendType: string;
  /** The Device ID */
  deviceId: string;
}

export interface ExecuteBatchDeviceCommandsParams {
  /** Specifies whether the command should be executed in order or asynchronously. */
  ordered?: boolean;
}

export interface ListDeviceGroupsParams {
  /** The device group locations to filter the results by. */
  locationId?: string[];
  /** The device group types to filter the results by. */
  groupType?: ('GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING')[];
}

export interface DeleteLocationParams {
  /** Skip syncing the delete to Data-Management. */
  skipDm?: boolean;
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'https://gizmo.st.internal';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Device API
 * @version v20170916.0.5
 * @baseUrl https://gizmo.st.internal
 *
 * Device API.
 */
export class GizmoApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  devices = {
    /**
     * @description Get a list of devices.
     *
     * @tags Devices
     * @name GetDevices
     * @summary List devices.
     * @request GET:/devices
     * @secure
     */
    getDevices: (query: GetDevicesParams, params: RequestParams = {}) =>
      this.request<PagedDevices, ErrorResponse>({
        path: `/devices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a device's description.
     *
     * @tags Devices
     * @name GetDevice
     * @summary Get a device's description.
     * @request GET:/devices/{deviceId}
     * @secure
     */
    getDevice: ({ deviceId, ...query }: GetDeviceParams, params: RequestParams = {}) =>
      this.request<Device, ErrorResponse>({
        path: `/devices/${deviceId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Device with a given Device ID. If the OAuth token used for this call is for a SmartApp that created the Device you are attempting to delete, the call implicitly has permission for this API.
     *
     * @tags Devices
     * @name DeleteDevice
     * @summary Delete a Device
     * @request DELETE:/devices/{deviceId}
     * @secure
     */
    deleteDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeleteDeviceCommandsResponse, ErrorResponse>({
        path: `/devices/${deviceId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the properties of a Device. If the OAuth token used for this call is for a SmartApp that created the Device you are attempting to update, the call implicitly has permission for this API.
     *
     * @tags Devices
     * @name UpdateDevice
     * @summary Update a Device
     * @request PUT:/devices/{deviceId}
     * @secure
     */
    updateDevice: (deviceId: string, updateDeviceRequest: UpdateDeviceRequest, params: RequestParams = {}) =>
      this.request<Device, ErrorResponse>({
        path: `/devices/${deviceId}`,
        method: 'PUT',
        body: updateDeviceRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Execute a specified command on a Device.
     *
     * @tags Devices
     * @name ExecuteDeviceCommands
     * @summary Execute Commands on a Device
     * @request POST:/devices/{deviceId}/commands
     * @secure
     */
    executeDeviceCommands: (
      { deviceId, ...query }: ExecuteDeviceCommandsParams,
      executeCapabilityCommand: DeviceCommandsRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeviceCommandsResponse, ErrorResponse>({
        path: `/devices/${deviceId}/commands`,
        method: 'POST',
        query: query,
        body: executeCapabilityCommand,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create events for a Device. When a Device is managed by a SmartApp, the Device is responsible for creating events to update the Device attributes on the SmartThings Platform. The OAuth token used must be for the SmartApp that created the Device.
     *
     * @tags Devices
     * @name CreateDeviceEvents
     * @summary Create Device Events
     * @request POST:/devices/{deviceId}/events
     * @secure
     */
    createDeviceEvents: (deviceId: string, deviceEventRequest: DeviceEventsRequest, params: RequestParams = {}) =>
      this.request<CreateDeviceEventsResponse, ErrorResponse>({
        path: `/devices/${deviceId}/events`,
        method: 'POST',
        body: deviceEventRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the profile used by the device. This is only available for SmartApp managed devices by the SmartApp that created the device. This is useful when a device instance needs to be migrated to a new profile.
     *
     * @tags Devices
     * @name UpdateProfileForDevice
     * @summary Update the profile used by the device.
     * @request PUT:/devices/{deviceId}/profile
     * @secure
     */
    updateProfileForDevice: (
      deviceId: string,
      updateDeviceProfileRequest: UpdateDeviceProfileRequest,
      params: RequestParams = {},
    ) =>
      this.request<Device, ErrorResponse>({
        path: `/devices/${deviceId}/profile`,
        method: 'PUT',
        body: updateDeviceProfileRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the current status of all of a Device component's attributes. The results may be filtered if the requester only has permission to view a subset of the Device's components or capabilities. If the OAuth token used in this API call is for a SmartApp that created the Device, it implicitly has permission for this API. DEPRECATION NOTICE: healthState is no longer included in response.
     *
     * @tags Devices
     * @name GetDeviceStatus
     * @summary Get the Full Status of a Device
     * @request GET:/devices/{deviceId}/status
     * @secure
     */
    getDeviceStatus: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeviceStatus, ErrorResponse>({
        path: `/devices/${deviceId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Gets the set of preference values defined for the device.
     *
     * @tags Devices
     * @name GetDevicePreferences
     * @summary Get a device's preference values.
     * @request GET:/devices/{deviceId}/preferences
     * @secure
     */
    getDevicePreferences: (deviceId: string, params: RequestParams = {}) =>
      this.request<DevicePreferenceResponse, ErrorResponse>({
        path: `/devices/${deviceId}/preferences`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the value of a preference for the device.
     *
     * @tags Devices
     * @name SetDevicePreference
     * @summary Set the value of a preference.
     * @request PUT:/devices/{deviceId}/preferences/{preferenceId}
     * @secure
     */
    setDevicePreference: (
      deviceId: string,
      preferenceId: string,
      updateDeviceParameterRequest: UpdateDeviceParameterRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/devices/${deviceId}/preferences/${preferenceId}`,
        method: 'PUT',
        body: updateDeviceParameterRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete the value of a the preference for the device. Future get requests will return the default or null if a default is not defined in the preference definition.
     *
     * @tags Devices
     * @name DeleteDevicePreference
     * @summary Remove the value of a preference.
     * @request DELETE:/devices/{deviceId}/preferences/{preferenceId}
     * @secure
     */
    deleteDevicePreference: (deviceId: string, preferenceId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/devices/${deviceId}/preferences/${preferenceId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Get the current health state of a given Device.
     *
     * @tags Devices
     * @name GetDeviceHealth
     * @summary Get the Health State of a Device
     * @request GET:/devices/{deviceId}/health
     * @secure
     */
    getDeviceHealth: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeviceHealthState, ErrorResponse>({
        path: `/devices/${deviceId}/health`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the status of all attributes of a specified component. The results may be filtered if the requester only has permission to view a subset of the component's capabilities. If the OAuth token used in this API call is for a SmartApp that created the Device, it implicitly has permission for this API.
     *
     * @tags Devices
     * @name GetDeviceComponentStatus
     * @summary Get the Status of a Device Component
     * @request GET:/devices/{deviceId}/components/{componentId}/status
     * @secure
     */
    getDeviceComponentStatus: (deviceId: string, componentId: string, params: RequestParams = {}) =>
      this.request<ComponentStatus, ErrorResponse>({
        path: `/devices/${deviceId}/components/${componentId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the current status of a Device component's capability. If the OAuth token used in this API call is for a SmartApp that created the Device, it implicitly has permission for this API.
     *
     * @tags Devices
     * @name GetDeviceStatusByCapability
     * @summary Get the Status of a Capability
     * @request GET:/devices/{deviceId}/components/{componentId}/capabilities/{capabilityId}/status
     * @secure
     */
    getDeviceStatusByCapability: (
      deviceId: string,
      componentId: string,
      capabilityId: string,
      params: RequestParams = {},
    ) =>
      this.request<CapabilityStatus, ErrorResponse>({
        path: `/devices/${deviceId}/components/${componentId}/capabilities/${capabilityId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Add/Remove locations where user-level device is shared with
     *
     * @tags Devices
     * @name ShareDevice
     * @summary share device with locations
     * @request PATCH:/devices/{deviceId}/share
     * @secure
     */
    shareDevice: (deviceId: string, deviceShareRequest: DeviceShareRequest, params: RequestParams = {}) =>
      this.request<DeviceShareResponse, ErrorResponse>({
        path: `/devices/${deviceId}/share`,
        method: 'PATCH',
        body: deviceShareRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  client = {
    /**
     * @description Gets the set of preference values defined for the device. This endpoint is temporary and intended for the client to use to fetch both the values and definition of a preference at the same time.
     *
     * @tags Devices
     * @name ClientGetDevicePreferences
     * @summary Get a device's preference values.
     * @request GET:/client/devices/{deviceId}/preferences
     * @secure
     */
    clientGetDevicePreferences: (deviceId: string, params: RequestParams = {}) =>
      this.request<ExtendedDevicePreferenceResponse, ErrorResponse>({
        path: `/client/devices/${deviceId}/preferences`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devicebackends = {
    /**
     * @description List the devices for the backend filtered by location ids supplied in the query params. At least one location id must be supplied.
     *
     * @tags devicebackends
     * @name ListBackendDevices
     * @summary Backend list device
     * @request GET:/devicebackends/{backendType}
     * @secure
     */
    listBackendDevices: ({ backendType, ...query }: ListBackendDevicesParams, params: RequestParams = {}) =>
      this.request<PagedBackendDevices, any>({
        path: `/devicebackends/${backendType}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new device for the backend. This should be called once the backend has completed it's backend dependant join mechanism.
     *
     * @tags devicebackends
     * @name CreateBackendDevice
     * @summary Backend create device
     * @request POST:/devicebackends/{backendType}
     * @secure
     */
    createBackendDevice: (backendType: string, createDevice: BackendInstallRequest, params: RequestParams = {}) =>
      this.request<BackendDevice, any>({
        path: `/devicebackends/${backendType}`,
        method: 'POST',
        body: createDevice,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the device by id for the specified backend.
     *
     * @tags devicebackends
     * @name GetBackendDevice
     * @summary Backend get device by id
     * @request GET:/devicebackends/{backendType}/{deviceId}
     * @secure
     */
    getBackendDevice: ({ backendType, deviceId, ...query }: GetBackendDeviceParams, params: RequestParams = {}) =>
      this.request<BackendDevice, any>({
        path: `/devicebackends/${backendType}/${deviceId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Selectively update the device record for a backend. Examples include switching device profiles in response to capability changes, syncing and device supplied data.
     *
     * @tags devicebackends
     * @name PatchDevice
     * @summary Backend selective update a device.
     * @request PATCH:/devicebackends/{backendType}/{deviceId}
     * @secure
     */
    patchDevice: (
      backendType: string,
      deviceId: string,
      backendUpdateRequest: BackendUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<BackendDevice, any>({
        path: `/devicebackends/${backendType}/${deviceId}`,
        method: 'PATCH',
        body: backendUpdateRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a backend device.
     *
     * @tags devicebackends
     * @name DeleteBackendDevice
     * @summary Backend delete a device
     * @request DELETE:/devicebackends/{backendType}/{deviceId}
     * @secure
     */
    deleteBackendDevice: (backendType: string, deviceId: string, params: RequestParams = {}) =>
      this.request<DeleteDeviceCommandsResponse, any>({
        path: `/devicebackends/${backendType}/${deviceId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create events for a backend device. Backends manage the translation of their integration protocols to Capabilities. When Capability attributes need to be updated the backend should create the approriate events. This will update the state of the device attributes.
     *
     * @tags devicebackends
     * @name CreateBackendDeviceEvents
     * @summary Backend create device events
     * @request POST:/devicebackends/{backendType}/{deviceId}/events
     * @secure
     */
    createBackendDeviceEvents: (
      backendType: string,
      deviceId: string,
      deviceEventRequest: BackendDeviceEventsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateBackendEventsResponse, ErrorResponse>({
        path: `/devicebackends/${backendType}/${deviceId}/events`,
        method: 'POST',
        body: deviceEventRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the state of a set of capabilities for a device.
     *
     * @tags devicebackends
     * @name GetBackendDeviceCapabilityState
     * @summary Backend get capability state
     * @request POST:/devicebackends/{backendType}/{deviceId}/status
     * @secure
     */
    getBackendDeviceCapabilityState: (
      backendType: string,
      deviceId: string,
      deviceStatusQuery: DeviceStatusQuery,
      params: RequestParams = {},
    ) =>
      this.request<DeviceStatus, ErrorResponse>({
        path: `/devicebackends/${backendType}/${deviceId}/status`,
        method: 'POST',
        body: deviceStatusQuery,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Gets the set of preference values defined for the device.
     *
     * @tags Devices
     * @name BackendGetDevicePreferences
     * @summary Get a device's preference values.
     * @request GET:/devicebackends/{backendType}/{deviceId}/preferences
     * @secure
     */
    backendGetDevicePreferences: (backendType: string, deviceId: string, params: RequestParams = {}) =>
      this.request<DevicePreferenceResponse, ErrorResponse>({
        path: `/devicebackends/${backendType}/${deviceId}/preferences`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the current health state for a device.
     *
     * @tags devicebackends
     * @name GetBackendDeviceHealthState
     * @summary Backend get health state
     * @request GET:/devicebackends/{backendType}/{deviceId}/health
     * @secure
     */
    getBackendDeviceHealthState: (backendType: string, deviceId: string, params: RequestParams = {}) =>
      this.request<DeviceHealthResponse, ErrorResponse>({
        path: `/devicebackends/${backendType}/${deviceId}/health`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the health state of a device, and maybe a defined set of its children.
     *
     * @tags devicebackends
     * @name UpdateDeviceHealthState
     * @summary Update the health state of the device
     * @request PUT:/devicebackends/{backendType}/{deviceId}/health
     * @secure
     */
    updateDeviceHealthState: (
      backendType: string,
      deviceId: string,
      healthState: UpdateDeviceHealthRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeviceHealthResponse, ErrorResponse>({
        path: `/devicebackends/${backendType}/${deviceId}/health`,
        method: 'PUT',
        body: healthState,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the enrollment settings for active health monitoring.
     *
     * @tags devicebackends
     * @name GetDeviceHealthEnrollment
     * @summary Get the enrollment settings for active health monitoring
     * @request GET:/devicebackends/{backendType}/{deviceId}/health/enrollment
     * @secure
     */
    getDeviceHealthEnrollment: (
      { backendType, deviceId, ...query }: GetDeviceHealthEnrollmentParams,
      params: RequestParams = {},
    ) =>
      this.request<DeviceHealthEnrollmentResponse, ErrorResponse>({
        path: `/devicebackends/${backendType}/${deviceId}/health/enrollment`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete the enrollment settings for active health monitoring.
     *
     * @tags devicebackends
     * @name DeleteDeviceHealthEnrollment
     * @summary Remove active health monitoring
     * @request DELETE:/devicebackends/{backendType}/{deviceId}/health/enrollment
     * @secure
     */
    deleteDeviceHealthEnrollment: (
      { backendType, deviceId, ...query }: DeleteDeviceHealthEnrollmentParams,
      params: RequestParams = {},
    ) =>
      this.request<JsonObject, ErrorResponse>({
        path: `/devicebackends/${backendType}/${deviceId}/health/enrollment`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devicesinternal = {
    /**
     * @description Create device from Data-management for DTH devices.
     *
     * @tags devicesinternal
     * @name InternalDeviceCreate
     * @summary Create device from Data-management.
     * @request POST:/devicesinternal
     * @secure
     */
    internalDeviceCreate: (device: InternalDevice, params: RequestParams = {}) =>
      this.request<JsonObject, any>({
        path: `/devicesinternal`,
        method: 'POST',
        body: device,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sync delete from Data-management.
     *
     * @tags devicesinternal
     * @name InternalDeviceDelete
     * @summary Sync delete from Data-management.
     * @request DELETE:/devicesinternal/{deviceId}
     * @secure
     */
    internalDeviceDelete: (deviceId: string, params: RequestParams = {}) =>
      this.request<JsonObject, any>({
        path: `/devicesinternal/${deviceId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sync device from Data-management.
     *
     * @tags devicesinternal
     * @name InternalDeviceSync
     * @summary Sync device from Data-management.
     * @request PUT:/devicesinternal/{deviceId}
     * @secure
     */
    internalDeviceSync: (deviceId: string, device: InternalDevice, params: RequestParams = {}) =>
      this.request<JsonObject, any>({
        path: `/devicesinternal/${deviceId}`,
        method: 'PUT',
        body: device,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Route commands from Data-management.
     *
     * @tags devicesinternal
     * @name InternalCommands
     * @summary Route commands from Data-management.
     * @request POST:/devicesinternal/{deviceId}/commands
     * @secure
     */
    internalCommands: (deviceId: string, commands: InternalCommands, params: RequestParams = {}) =>
      this.request<DeviceCommandsResponse, ErrorResponse>({
        path: `/devicesinternal/${deviceId}/commands`,
        method: 'POST',
        body: commands,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description When witness receives an event for a device that's offline, witness will set the device to online and inform gizmo via this endpoint so gizmo can perform any actions needed.
     *
     * @tags devicesinternal
     * @name PutHealthInternal
     * @summary Route device event triggered health events from witness.
     * @request PUT:/devicesinternal/{deviceId}/health
     * @secure
     */
    putHealthInternal: (deviceId: string, healthState: InternalDeviceHealthRequest, params: RequestParams = {}) =>
      this.request<DeviceHealthResponse, ErrorResponse>({
        path: `/devicesinternal/${deviceId}/health`,
        method: 'PUT',
        body: healthState,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  devicecategories = {
    /**
     * @description List Categories.
     *
     * @tags devicecategories
     * @name ListCategories
     * @summary List Device Categories
     * @request GET:/devicecategories
     * @secure
     */
    listCategories: (params: RequestParams = {}) =>
      this.request<PagedDeviceCategories, ErrorResponse>({
        path: `/devicecategories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devicecommands = {
    /**
     * @description Execute commands on multiple devices. Commands will be executed simultaneously where possible.
     *
     * @tags Devices
     * @name ExecuteBatchDeviceCommands
     * @summary Execute commands on multiple devices.
     * @request POST:/devicecommands
     * @secure
     */
    executeBatchDeviceCommands: (
      query: ExecuteBatchDeviceCommandsParams,
      executeCapabilityBatchCommand: BatchDeviceCommandsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateBatchDeviceCommandsResponse, ErrorResponse>({
        path: `/devicecommands`,
        method: 'POST',
        query: query,
        body: executeCapabilityBatchCommand,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  devicegroups = {
    /**
     * @description Get a list of device groups
     *
     * @tags devicegroups
     * @name ListDeviceGroups
     * @summary List all device groups for the user
     * @request GET:/devicegroups
     * @secure
     */
    listDeviceGroups: (query: ListDeviceGroupsParams, params: RequestParams = {}) =>
      this.request<PagedDeviceGroups, ErrorResponse>({
        path: `/devicegroups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new device group Upon group creation, the group type is decided based on the given input and the capabilities of the included devices; the resulting group type may not be what is passed in.
     *
     * @tags devicegroups
     * @name CreateDeviceGroup
     * @summary create a device group
     * @request POST:/devicegroups
     * @secure
     */
    createDeviceGroup: (request: DeviceGroupCreateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, ErrorResponse>({
        path: `/devicegroups`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single device group by Id
     *
     * @tags devicegroups
     * @name GetDeviceGroup
     * @summary Show device group by id
     * @request GET:/devicegroups/{deviceGroupId}
     * @secure
     */
    getDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description update device group with a new set of devices or name. Keep same id.
     *
     * @tags devicegroups
     * @name UpdateDeviceGroup
     * @summary Update device group with a new set of devices or a name. Keep same id.
     * @request PUT:/devicegroups/{deviceGroupId}
     * @secure
     */
    updateDeviceGroup: (deviceGroupId: string, request: DeviceGroupUpdateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete device group based on deviceGroupId
     *
     * @tags devicegroups
     * @name DeleteDeviceGroup
     * @summary Delete device group based on deviceGroupId
     * @request DELETE:/devicegroups/{deviceGroupId}
     * @secure
     */
    deleteDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupDeleteResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Gets status of all devices in the group, and an aggregate. The capabilities returned here are not a complete list of the group's, or individual devices', capabilities. For that, please use the /devicegroups/{deviceGroupId} endpoint.
     *
     * @tags devicegroups
     * @name GetDeviceGroupStatus
     * @summary Show status of all devices in a group
     * @request GET:/devicegroups/{deviceGroupId}/status
     * @secure
     */
    getDeviceGroupStatus: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupStatusGizmoResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Execute a device group command.
     *
     * @tags devicegroups
     * @name ExecuteDeviceGroupCommand
     * @summary Execute a device group command.
     * @request POST:/devicegroups/{deviceGroupId}/commands
     * @secure
     */
    executeDeviceGroupCommand: (
      deviceGroupId: string,
      executeDeviceGroupCommand: DeviceGroupCommandRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeviceGroupCommandResponse, ErrorResponse>({
        path: `/devicegroups/${deviceGroupId}/commands`,
        method: 'POST',
        body: executeDeviceGroupCommand,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  devicegroupsinternal = {
    /**
     * @description Internal endpoint to retrieve device groups info
     *
     * @tags devicegroupsinternal
     * @name GetInternalDeviceGroups
     * @summary Service token endpoint to retrieve a device group
     * @request GET:/devicegroupsinternal/{deviceGroupId}
     * @secure
     */
    getInternalDeviceGroups: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<InternalDeviceGroup, ErrorResponse>({
        path: `/devicegroupsinternal/${deviceGroupId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  locations = {
    /**
     * @description Delete all of the devices in a location. This is for cleaning up on devices as part of a location delete. A 404 indicates that there are no devices in the given location.
     *
     * @tags locations
     * @name DeleteLocation
     * @summary Delete all devices in a location.
     * @request DELETE:/locations/{locationId}/devices
     * @secure
     */
    deleteLocation: ({ locationId, ...query }: DeleteLocationParams, params: RequestParams = {}) =>
      this.request<DeviceGroupDeleteResponse, ErrorResponse>({
        path: `/locations/${locationId}/devices`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Add Devices to an existing room along with the order. This will move a Device if it is already in another room.  This endpoint can also be used to change the location of a device by providing a new location id in the URL (Restrictions: the device cannot be a DTH Device and the new location must be in the same shard as the current one)
     *
     * @tags locations
     * @name AddDevicesToRoom
     * @summary Add/Move Devices to Room.
     * @request PUT:/locations/{locationId}/rooms/{roomId}/devices
     * @secure
     */
    addDevicesToRoom: (
      locationId: string,
      roomId: string,
      AddDevicesToRoomRequest: AddDevicesToRoomRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddDevicesToRoomResponse, ErrorResponse>({
        path: `/locations/${locationId}/rooms/${roomId}/devices`,
        method: 'PUT',
        body: AddDevicesToRoomRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete Devices from an existing room.
     *
     * @tags locations
     * @name DeleteDevicesFromRoom
     * @summary Delete Devices from Room.
     * @request DELETE:/locations/{locationId}/rooms/{roomId}/devices
     * @secure
     */
    deleteDevicesFromRoom: (
      locationId: string,
      roomId: string,
      RemoveDevicesFromRoomRequest: RemoveDevicesFromRoomRequest,
      params: RequestParams = {},
    ) =>
      this.request<RemoveDevicesFromRoomResponse, ErrorResponse>({
        path: `/locations/${locationId}/rooms/${roomId}/devices`,
        method: 'DELETE',
        body: RemoveDevicesFromRoomRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Devices belonging to an existing room
     *
     * @tags locations
     * @name GetDevicesFromRoom
     * @summary Get Devices belonging to Room
     * @request GET:/locations/{locationId}/rooms/{roomId}/devices
     * @secure
     */
    getDevicesFromRoom: (locationId: string, roomId: string, params: RequestParams = {}) =>
      this.request<PagedDevices, ErrorResponse>({
        path: `/locations/${locationId}/rooms/${roomId}/devices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  ocfic = {
    /**
     * @description Get an OCF device profile representation of a device
     *
     * @tags ocfic
     * @name GetOcfDeviceProfile
     * @summary Get OIC/P
     * @request GET:/ocfic/{deviceId}/profile
     * @secure
     */
    getOcfDeviceProfile: (deviceId: string, params: RequestParams = {}) =>
      this.request<OcfDeviceProfile, ErrorResponse>({
        path: `/ocfic/${deviceId}/profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get all SmartThings (non-OCF) devices
     *
     * @tags ocfic
     * @name OcfInterconnectList
     * @summary OCF Interconnect list
     * @request GET:/ocfic
     * @secure
     */
    ocfInterconnectList: (params: RequestParams = {}) =>
      this.request<OcfDeviceProfiles, any>({
        path: `/ocfic`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get an OCF device profile representation of a device
     *
     * @tags ocfic
     * @name OcfInterconnectDelete
     * @summary OCF Interconnect DELETE
     * @request DELETE:/ocfic/{deviceId}
     * @secure
     */
    ocfInterconnectDelete: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeleteDeviceCommandsResponse, ErrorResponse>({
        path: `/ocfic/${deviceId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  internal = {
    /**
     * @description Making a post request to this endpoint will migrate (make an attempt) all devices in the given location to OCF Account
     *
     * @tags internal
     * @name MigrateDevices
     * @summary app migrations endpoint
     * @request POST:/internal/support/{locationId}/migrate
     * @secure
     */
    migrateDevices: (deviceId: string, locationId: string, params: RequestParams = {}) =>
      this.request<DeviceMigrationResponse, ErrorResponse>({
        path: `/internal/support/${locationId}/migrate`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
